<template>
  <v-menu content-class="qtm-border" offset-y>
    <template v-slot:activator="{ props }">
      <qtm-btn v-bind="props" secondary>
        {{ number }}
        <v-icon location="right">
          mdi-chevron-down
        </v-icon>
      </qtm-btn>
    </template>
    <v-list dense>
      <v-list-item nuxt target="_blank" :to="{ name: 'orders-id-change-order', params: { id: order.id } }">
        <v-list-item-title>
          Edit

          <v-icon class="external-link" size="x-small">
            mdi-open-in-new
          </v-icon>
        </v-list-item-title>
      </v-list-item>

      <admin-link-list-item :to="`rfqs/purchaseorder/${id}/change/`">
        Admin
      </admin-link-list-item>

      <admin-link-list-item api-link :to="`pos/${id}/pdf/`">
        Download PDF
      </admin-link-list-item>
    </v-list>
  </v-menu>
</template>

<script setup lang="ts">
import type { Order } from '@quotetome/materials-api'
import AdminLinkListItem from '@/components/admin/admin-link-list-item.vue'

export interface Props {
  id: number
  number?: string
  order: Order
}

withDefaults(defineProps<Props>(), {
  number: 'Purchase Order'
})
</script>

<style lang="scss" scoped>
.v-icon.external-link {
  margin-left: 3px;
  position: relative;
  top: -5px;
}
</style>
